import { ReactNode, useMemo } from 'react';
import { Link } from 'react-router';

export interface BreadcrumbItem {
    title: string;
    href?: string;
}

export default function useBreadcrumbItems(items: BreadcrumbItem[]): ReactNode[] {
    return useMemo(() => {
        return items.map((item, index) => {
            const isLast = index === items.length - 1;

            if (isLast) {
                return (
                    <span key={`${item.title}-${index}`} className="text-fg" aria-current="page">
                        {item.title}
                    </span>
                );
            }

            if (!item.href || item.href === '#') {
                return (
                    <span key={`${item.title}-${index}`} className="text-fg/68">
                        {item.title}
                    </span>
                );
            }

            return (
                <Link
                    to={item.href}
                    key={`${item.title}-${index}`}
                    className="inline-flex items-center min-h-6 text-fg/78 transition-colors duration-200 ease-out hover:text-fg"
                >
                    {item.title}
                </Link>
            );
        });
    }, [items]);
}
